// src/App.js
import React, { useState, useEffect, useCallback } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { ShoppingCart, X } from "lucide-react";
import { debounce } from "lodash";
import { orderBy } from "firebase/firestore";
import PaymentSuccess from "./PaymentSuccess.jsx";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useParams,
} from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import emailjs from "@emailjs/browser";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import "./App.css";




/* ₺ para formatı */
const fmt = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY" }).format(
    n
  );

/* 🎁 Kategoriler */
const CATEGORIES = [
  {
    id: "dokme",
    name: "AMBROSIA Dökme Badem ",
    enName: "AMBROSIA Bulk Almonds",
    image: "ambrosiasutlubadem1.jpg",
    products: [
      { name: "AMBROSIA Sütlü Badem Handmade / Milk Almond 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (dairy product), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place at 15-20°C, maximum 70% relative humidity, after removing odors. Allergen Information: Contains dairy product, traces of soy product, pistachios, almonds and gluten.",
        price: 1396,
        images: ["/ambrosiasutlubadem.jpg","/ambrosiasutlubadem1.jpg"],
      },
      
      
      
      { name: "AMBROSIA Antep Fıstık Sütlü Handmade / Milk Pistachio 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1796,
        images: ["/ambrosiasutlufistik.jpg","/ambrosiasutlufistik(2).JPG"],
      },
      { name: "AMBROSIA Antep Fıstık Bitter Handmade / Bitter Pistachio 500gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1796 ,
        images:["/ambrosiabitterfistik.jpg","/ambrosiabitterfistik2.JPG"],
      },
    ],
  },
  {
    id: "badem",
    name: "Badem Serisi",
    enName: "Almond Series",
    image: "ambrosiasutlubadem1.jpg",
    products: [
      { name: "AMBROSİA Sütlü Badem Handmade / Milk Almond 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396,
        images: ["/ambrosiasutlubadem.jpg","/ambrosiasutlubadem1.jpg"],
      },
      { name: "AMBROSİA Bitter Badem Handmade / Bitter Almond 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396,
        images: ["/ambrosiabitterbadem.jpg","/ambrosiabitterbadem2.JPG"]
      },
      { name: "PHYLLIS Sütlü Badem / Milk Almond 320gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 968 ,
        images:["/phylissutlubadem.jpg"],
      },
      
      { name: "PHYLLIS Bitter Badem / Bitter Almond 320gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 968,
        images: ["/phylisbitterbadem.jpg"]
      },
      
    ],
  },
  {
    id: "fistik",
    name: "Antep Fıstık Serisi",
    enName: "Pistachio Series",
    image: "/arcadiaantepfistiklibitter.jpg",
    products: [
      { name: "ARCADIA Bitter Antep Fıstık / Pistachio Milk Bitter White Gold 350gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396 ,
        images:["/arcadiaantepfistiklibitter.jpg"]
      },
      { name: "ARCADIA Sütlü Antep Fıstık / Pistachio Milk Bitter White Gold 350gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, süt yağı, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, milk fat, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396 ,
        images:["/arcadiaantepfistiklisutlu.jpg"],
      },
      { name: "AMBROSIA Antep Fıstık Sütlü Handmade / Milk Pistachio 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1696,
        images: ["/ambrosiasutlufistik.jpg","/ambrosiasutlufistik2.jpg"],
      },
      { name: "AMBROSIA Antep Fıstık Bitter Handmade / Bitter Pistachio 500gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1696 ,
        images:["/ambrosiabitterfistik.jpg","/ambrosiabitterfistik2.JPG"],
      },
    ],
  },
  {
    id:"tabletserisi",
    name: "ORACLE Özel Tablet ",
    enName: "ORACLE Premium Tablet Series",
    image:"TABLETLER.jpg",
    products: [
      {
        name: "ORACLE Özel Tabletler Serisi / ORACLE Special Tablets Series",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa powder, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C and a maximum of 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1596,
        images: ["TABLETLER.jpg"],
      },
      {
        name: "ORACLE Beyaz Tablet / White Tablets 110gr",
        description:"İçindekiler:Şeker, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:12-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place, away from odors, at 12-20°C and a maximum of 70% relative humidity. Allergen Information: Contains dairy products; may contain traces of soy products, hazelnuts, pistachios, almonds, and gluten.",
        price: 396 ,
        images:["/TABLETBEYAZ.jpg"],
      },
      {
        name: "ORACLE Bitter Tablet / Bitter Tablets 110gr ",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa powder, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C and a maximum of 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 396 ,
        images:["/TABLETBİTTER.jpg"],
      },
      {
        name: "ORACLE Gold Tablet / Gold Tablets 110gr",
        description:"İçindekiler:Karamelize şeker, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Caramelized sugar, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place at 15-20°C, maximum 70% relative humidity, away from odors. Allergen Information: Contains dairy products, may contain traces of soy products, hazelnuts, pistachios, almonds and gluten.",
        price: 396 ,
        images:["/TABLETGOLD.jpg"],
      },
      {
        name: "ORACLE Ruby Tablet / Ruby Tablets 110gr",
        description:"İçindekiler:Şeker, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place at 15-20°C, maximum 70% relative humidity, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 396 ,
        images:["/TABLETRUBY.jpg"],
      },
      {
        name: "ORACLE Sütlü Tablet / Milk Tablets 110gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa powder, cocoa butter, whole milk powder, emulsifier: lecithins (soy), natural vanilla. Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C and a maximum of 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 396 ,
        images:["/TABLETSÜTLÜ.jpg"],
      },
    ]
  },
  {
    id: "yilbasi",
    name: "JANUS Yılbaşı",
    enName: "JANUS New Year",
    image: "yilbasi.jpg",
    products: [
      { name: "JANUS Yeniyıl Çikolata / New Year Handmade Chocolate 1 260gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, süt yağı, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, milk fat, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1986,
        images: ["/yilbasi.jpg"],
      },
      { name: "JANUS Yeniyıl Çikolata / New Year Handmade Chocolate 2 260gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, süt yağı, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, milk fat, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 2286,
        images: ["/yilbasi1.jpg"],
      },
    ],
  },
  {
    id: "ogretmenler-gunu",
    name: "ATHENA Öğretmenler Günü",
    enName: "ATHENA Teachers Day",
    image: "ogretmenlergunu1.jpg",
    products: [
      { name: "Athena Öğretmenler Günü Kutusu / ATHENA Teachers Day 120gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, süt yağı, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, milk fat, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 2096,
        images: ["/ogretmenlergunu.jpg"],
      },
      
      
    ],
  },
  {
    id: "sevgililer-gunu",
    name: "OLYMPUS Özel Seri",
    enName: "OLYMPUS Special Chocolate",
    image: "tarcinli.jpg",
    products: [
      { name: "Olympus Özel Seri / Karamel Premium Caramel Bon Bon 160gr", 
        description:"İçindekiler:Şeker, kakao yağı, kakao killesi, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya, su, krema, bal, tereyağ. Saklama Koşulları:12-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa butter, cocoa clay, whole milk powder, emulsifier: lecithins (soy), natural vanilla, water, cream, honey, butter. Storage Conditions: Store in a cool, dry place, away from odors, at 12-20°C and a maximum of 70% relative humidity. Allergen Information: Contains dairy products; may contain traces of soy products, hazelnuts, pistachios, almonds, and gluten.",
        price: 896,
        images: ["/tarcinli.jpg","/tarcinli2.JPG"],
      },
      { name: "Olympus Özel Seri / Frambuazlı Premium Raspberry Bon Bon 160gr", 
        description:"İçindekiler:Şeker, tam yağlı süt tozu, emülgatör: lesitinler(soya), doğal vanilya, glikoz şurubu, %100 antep fıstığı, Frambuaz püresi, pektin, sitrik asit. Saklama Koşulları:12-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, whole milk powder, emulsifier: lecithins (soy), natural vanilla, glucose syrup, 100% pistachios, raspberry puree, pectin, citric acid. Storage Conditions: Store in a cool, dry place, away from odors, at 12-20°C and a maximum of 70% relative humidity. Allergen Information: Contains dairy products; may contain traces of soy products, hazelnuts, pistachios, almonds, and gluten.",
        price: 896,
        images: ["/frambuazli.jpg","/frambuazli2.JPG"],
      },
    ],
  },
  {
    id: "bayramlar",
    name: "THALIA Hediyelik",
    enName: "THALIA Gift Chocolate",
    image: "karisikantepfistik.jpg",
    products: [
      { name: "ARCADIA Fıstık Cranberry / Pistachio milk bitter white gold 430gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1786 ,
        images: ["/karisikantepfistik.jpg"]
      },
      { name: "ARCADIA Fıstık Cranberry / Pistachio milk bitter white gold 430gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1786 ,
        images: ["/karisikantepfistik1.jpg"],
      },
      { name: "ARCADIA Badem Cranberry / Almond Cranberry milk bitter white gold 430gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1496 ,
        images: ["/Arcadiasutlubadem.jpg"],
      },
      { name: "ARCADIA Fıstık Gojiberry / Pistachio milk bitter White Gold 250gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 996,
        images: ["/bayramfistik.jpg"],
      },
      { name: "ARCADIA Badem Cranberry / Almond Milk Bitter White Gold 250gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 796,
        images: ["/bayrambadem.jpg"],
      },
      { name: "AMBROSIA Badem Sütlü Dökme Handmade / Milk Almond 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu, emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396,
        images: ["/ambrosiasutlubadem.jpg","/ambrosiasutlubadem1.jpg"],
      },
      { name: "AMBROSIA Badem Bitter Handmade / Bitter Almond 510gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1489,
        images: ["/ambrosiabitterbadem.jpg","/ambrosiabitterbadem2.JPG"]
      },
      { name: "PHYLLIS Sütlü Badem / Milk Almond 350gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 989 ,
        images:["/phylissutlubadem.jpg"],
      },
      { name: "PHYLLIS Bitter Badem / Bitter Almond 360gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), tam yağlı süt tozu,yağsız süt tozu, süt yağı, karamelize şeker, aroma verici(vanilya) emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), whole milk powder, skimmed milk powder, milk fat, caramelized sugar, flavoring (vanilla), emulsifier (sunflower lecithin). Storage Conditions: Store in a cool, dry place, away from odors, at 15-20°C, maximum 70% relative humidity. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1096,
        images: ["/phylisbitterbadem.jpg"]
      },
      { name: "ARCADIA Bitter Antep Fıstık / Pistachio bitter 350gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396 ,
        images:["/arcadiaantepfistiklibitter.jpg"]
      },
      { name: "ARCADIA Sütlü Antep Fıstık / Pistachio Milk 350gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396 ,
        images:["/arcadiaantepfistiklisutlu.jpg"],
      },
      { name: "Antep Fıstık Sütlü Handmade / Milk Pistachio 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1996,
        images: ["/ambrosiasutlufistik.jpg","/ambrosiasutlufistik(2).JPG"],
      },
      { name: "Antep Fıstık Bitter Handmade / Bitter Almond 500gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1996 ,
        images:["/ambrosiabitterfistik.jpg","/ambrosiabitterfistik2.JPG"],
      },
    ],
  },
  {
    id: "promosyon",
    name: "HERMES Promosyon Grubu",
    enName: "HERMES Promotion Series",
    image: "promosyonserisi.jpg",
    products: [
      {
        name: "HERMES Badem Sütlü Çikolata / Almond Milk Chocolate 85gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 228,
        images: ["/hermes4karecikolata.jpg"],
      },
      { name: "HERMES Badem Sütlü Çikolata / Almond Milk Chocolate 110gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price:296,
        images: ["/hermes6karecikolata.jpg"],
      },
      { name: "HERMES Badem Sütlü Çikolata / Almond Milk Chocolate 100gr",
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini). Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 289,
        images: ["/hermes8karecikolata.jpg"],
      },
    ],
  },
  {
    id:"acı olmayan bitter",
    name:"Dengeli Yumuşak Bitter Badem",
    enName:"",
    image: "ambrosiabitterbadem.jpg",
    products: [
      { name: "AMBROSIA Bitter Badem Handmade / Bitter Almond 500gr", 
        description:"İçindekiler:Şeker, kakao killesi, kakao yağı, kakao tozu, peyniraltı suyu tozu(süt ürünü), emülgatör(ayçiçek lesitini. Saklama Koşulları:15-20 C derecede, max %70 bağlı nemde, serin ve kuru bir yerde, kokudan uzakta saklanır. Alerjen Bilgisi: Süt Ürünü içerir, eser miktarda soya ürünü, fındık, antep fıstığı, badem ve gluten içerebilir. Ingredients: Sugar, cocoa clay, cocoa butter, cocoa powder, whey powder (milk product), emulsifier (sunflower lecithin). Storage Conditions: Store at 15-20°C, maximum 70% relative humidity, in a cool, dry place, away from odors. Allergen Information: Contains milk product, may contain traces of soy product, hazelnuts, pistachios, almonds and gluten.",
        price: 1396,
        images: ["/ambrosiabitterbadem.jpg","/ambrosiabitterbadem2.JPG"]
      },
    ],
  },
];

const CAMPAIGN_COUPON = "ISAILEM";

const getCampaignDiscountRate = (categoryId) => {
  return categoryId === "aciolmayan" ? 0.50 : 0.20;
};
/* 🖼️ + 🎥 Hero Slider içerikleri (public klasöründen çağır) */
const HERO_SLIDES = [
  {
    type: "image",
    src: "/ambrosiasutlubadem1.jpg",
    title: "Badem Serisi",
    categoryId: "badem",
  },
  {
    type: "image",
    src: "/ambrosiasutlufistik2.jpg",
    title: "Antep Fıstık Serisi",
    categoryId: "fistik",
  },
  {
    type: "image",
    src: "/tarcinli2.JPG",
    title: "Olympus Özel Seri",
    categoryId: "sevgililer-gunu",
  },
  {
    type: "video",
    src: "/bamorcikolata.mp4",
    title: "Bayramlar",
    categoryId: "bayramlar",
  },
  {
    type: "image",
    src: "/frambuazli2.JPG",
    title: "Olympus Özel Seri",
    categoryId: "sevgililer-gunu",
  },
  {
    type: "video",
    src: "/bamorcikolata2.mp4",
    title: "Yılbaşı Kutuları",
    categoryId: "yilbasi",
  },
];

/* 🧲 Hero Carousel */
function HeroCarousel({ onGoToCategory }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % HERO_SLIDES.length);
    }, 4500);
    return () => clearInterval(t);
  }, []);

  const slide = HERO_SLIDES[index];

  const prev = () =>
    setIndex((i) => (i - 1 + HERO_SLIDES.length) % HERO_SLIDES.length);
  const next = () => setIndex((i) => (i + 1) % HERO_SLIDES.length);

  return (
    <div className="w-full max-w-6xl mx-auto px-6 pt-6">
      <div className="relative rounded-2xl overflow-hidden shadow-lg border border-[#09363c] bg-black">
        <div className="relative h-[260px] sm:h-[380px] md:h-[460px]">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              className="absolute inset-0"
              initial={{ opacity: 0, scale: 1.02 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 0.45, ease: "easeOut" }}
            >
              {slide.type === "video" ? (
                <video
                  src={slide.src}
                  className="w-full h-full object-cover"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              ) : (
                <img
                  src={slide.src}
                  alt={slide.title}
                  className="w-full h-full object-cover"
                />
              )}

              {/* overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-black/30" />

              {/* text + button */}
              {/* text + button (SOL ÜST) */}
<div className="absolute top-0 left-0 p-6 sm:p-8 text-[#F5E6C5] text-left">
  <div className="inline-block text-2xl sm:text-3xl font-gothic drop-shadow bg-black/35 px-4 py-2 rounded-xl backdrop-blur-sm">
    {slide.title}
  </div>

  <button
    onClick={() => onGoToCategory(slide.categoryId)}
    className="mt-4 bg-black/80 text-[#C6A667] px-6 py-2 rounded-lg hover:bg-black transition font-gothic tracking-[0.12em]"
  >
    Ürünlere Git
  </button>
</div>

            </motion.div>
          </AnimatePresence>

          {/* arrows */}
          <button
            onClick={prev}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 text-white px-3 py-2 rounded-full hover:bg-black/70"
          >
            ‹
          </button>
          <button
            onClick={next}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 text-white px-3 py-2 rounded-full hover:bg-black/70"
          >
            ›
          </button>

          {/* dots */}
          <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-2">
            {HERO_SLIDES.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`h-2.5 w-2.5 rounded-full ${
                  i === index ? "bg-[#C6A667]" : "bg-white/40"
                }`}
                aria-label={`slide-${i}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}


/* 🌳 Giriş animasyonu */
function IntroAnimation({ onFinish }) {
  useEffect(() => {
    const t = setTimeout(onFinish, 7500);
    return () => clearTimeout(t);
  }, [onFinish]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-black z-[9999] overflow-hidden">
      <div className="intro-tree-frame">
        <motion.img
          src="/bamor-tree.png"
          alt="Bamor Tree"
          className="intro-tree"
          initial={{
            opacity: 0,
            clipPath: "inset(100% 0% 0% 0%)", // hiç görünmesin
          }}
          animate={{
            opacity: [0, 1, 1, 1, 0],
            // kökten yukarı büyü -> full -> tekrar köke in -> yok ol
            clipPath: [
              "inset(80% 0% 0% 0%)", // sadece kökler (istersen 70/85 ile oyna)
              "inset(0% 0% 0% 0%)",  // full ağaç
              "inset(0% 0% 0% 0%)",
              "inset(80% 0% 0% 0%)", // tekrar köklere in
              "inset(100% 0% 0% 0%)" // tamamen yok ol
            ],
          }}
          transition={{
            duration: 7.5,
            times: [0, 0.15, 0.55, 0.85, 1],
            ease: "easeInOut",
          }}
        />
      </div>
    </div>
  );
}


/* 💳 ödeme sayfası — Kart bilgileri kaldırıldı */
function CheckoutPage({ cart, clearCart }) {
  const navigate = useNavigate();

  // Kupon alanları
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponError, setCouponError] = useState("");

  // Normal sepet toplamı
  const originalTotal = cart.reduce(
    (sum, item) => sum + item.qty * item.price,
    0
  );

  // Kupon uygulanmış ürün fiyatları
  const discountedCart = cart.map((item) => {
    if (!couponApplied) {
      return {
        ...item,
        originalPrice: item.price,
        discountedPrice: item.price,
        discountRate: 0,
      };
    }

    const discountRate = getCampaignDiscountRate(item.categoryId);

    const discountedPrice =
      Math.round(item.price * (1 - discountRate) * 100) / 100;

    return {
      ...item,
      originalPrice: item.price,
      discountedPrice,
      discountRate,
    };
  });

  // İndirimli toplam
  const finalTotal = discountedCart.reduce(
    (sum, item) => sum + item.qty * item.discountedPrice,
    0
  );

  // Toplam indirim
  const discountAmount = originalTotal - finalTotal;

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  const handleApplyCoupon = () => {
  const normalizedCode = couponCode.trim().toUpperCase();

  if (normalizedCode === CAMPAIGN_COUPON) {
    setCouponApplied(true);
    setCouponError("");
  } else {
    setCouponApplied(false);
    setCouponError("Geçersiz kupon kodu.");
  }
};

  /* Regex doğrulayıcılar */
  const validators = {
    name: (v) => v.trim().length > 2,
    email: (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
    phone: (v) => /^[0-9]{10,10}$/.test(v),
    address: (v) => v.trim().length > 5,
  };

 const handleChange = (e) => {
  const { name, value } = e.target;

  let newValue = value;

  if (name === "phone") {
    newValue = value.replace(/\D/g, "").slice(0, 10);
  }

  setForm((p) => ({ ...p, [name]: newValue }));
  setErrors((prev) => ({ ...prev, [name]: false }));
};

  const validateForm = () => {
    const newErrors = {};
    Object.keys(validators).forEach((key) => {
      if (!validators[key](form[key])) newErrors[key] = true;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("SUBMIT BAŞLADI");

  const isValid = validateForm();
  console.log("FORM VALID MI:", isValid, form);

  if (!isValid) {
    console.log("VALIDATION FAIL", errors);
    alert("Lütfen tüm alanları doğru doldurun.");
    return;
  }

  setSending(true);

  try {
  console.log("FETCH'E GİRİYOR");

  const orderId = "ORD-" + Date.now();

  const response = await fetch("/api/create-payment-form.php", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
  orderId: orderId,
  basketItems: cart,
  userDetails: form,
  couponCode: couponApplied ? CAMPAIGN_COUPON : null
})
  });

  console.log("RESPONSE GELDİ:", response.status, response.ok);

  const raw = await response.text();
  console.log("RAW RESPONSE:", raw);

  let data;
  try {
    data = JSON.parse(raw);
  } catch (parseErr) {
    console.error("JSON PARSE HATASI:", parseErr);
    alert("Sunucudan geçersiz cevap geldi.");
    return;
  }

  console.log("DATA:", data);

  if (data.status === "success") {
    localStorage.setItem("pendingOrderId", orderId);
    localStorage.setItem(
  "pendingCart",
  JSON.stringify(discountedCart)
);
    localStorage.setItem("pendingForm", JSON.stringify(form));

    if (data.paymentPageUrl) {
      window.location.href = data.paymentPageUrl;
      return;
    }

    if (data.checkoutFormContent) {
      const oldForm = document.getElementById("iyzipay-checkout-form");
      if (oldForm) oldForm.remove();

      const div = document.createElement("div");
      div.id = "iyzipay-checkout-form";
      div.innerHTML = data.checkoutFormContent;
      document.body.appendChild(div);

      const scripts = div.getElementsByTagName("script");
      Array.from(scripts).forEach((oldScript) => {
        const newScript = document.createElement("script");

        if (oldScript.src) {
          newScript.src = oldScript.src;
          newScript.async = true;
        } else {
          newScript.text = oldScript.innerHTML;
        }

        document.body.appendChild(newScript);
      });

      return;
    }
  }

  alert("Ödeme başlatılamadı: " + (data.errorMessage || "Bilinmeyen hata"));
} catch (err) {
  console.error("HATA:", err);
  alert("İstek sırasında hata oluştu.");
} finally {
  setSending(false);
}
};

  return (
    <div className="min-h-screen bg-[#06343a] text-[#f5e6c5] flex flex-col items-center pt-24">
      <button
        onClick={() => navigate("/cart")}
        className="mb-6 inline-flex items-center text-[#E8DCC3] gap-2 hover:underline"
      >
        <X size={20} /> Geri Dön
      </button>
      <h1 className="text-3xl font-gothic mb-6">Ödeme Bilgileri</h1>

      <form
        onSubmit={handleSubmit}
        className="bg-[#1f120b] text-[#E8DCC3] shadow rounded-lg p-6 w-full max-w-md space-y-4"
      >
        {/* Yeni form alanları */}
        <input
          name="name"
          type="text"
          placeholder="Ad Soyad"
          className="border p-2 w-full rounded-md bg-[#f5e6c5] text-[#2b170c]"
          value={form.name}
          onChange={handleChange}
        />
        {errors.name && (
          <p className="text-red-400 text-sm mt-1 italic">Geçerli bir isim girin.</p>
        )}

        <input
          name="email"
          type="email"
          placeholder="E-posta"
          className="border p-2 w-full rounded-md bg-[#f5e6c5] text-[#2b170c]"
          value={form.email}
          onChange={handleChange}
        />
        {errors.email && (
          <p className="text-red-400 text-sm mt-1 italic">Geçerli bir email girin.</p>
        )}

        <input
  name="phone"
  type="tel"
  placeholder="5XXXXXXXXX"
  className="border p-2 w-full rounded-md bg-[#f5e6c5] text-[#2b170c]"
  value={form.phone}
  onChange={handleChange}
  maxLength={10}
  inputMode="numeric"
/>
        {errors.phone && (
          <p className="text-red-400 text-sm mt-1 italic">Geçerli bir telefon girin.</p>
        )}

        <textarea
          name="address"
          placeholder="Adres"
          rows="3"
          className="border p-2 w-full rounded-md bg-[#f5e6c5] text-[#2b170c]"
          value={form.address}
          onChange={handleChange}
        />
        {errors.address && (
          <p className="text-red-400 text-sm mt-1 italic">Geçerli bir adres girin.</p>
        )}

        {/* İş Ailem Kupon Alanı */}
<div className="space-y-2">
  <label className="block text-sm">
    Kampanya / Kupon Kodu
  </label>

  <div className="flex gap-2">
    <input
      type="text"
      value={couponCode}
      onChange={(e) => {
        setCouponCode(e.target.value);
        setCouponError("");
      }}
      placeholder="Kupon kodunuzu girin"
      className="border p-2 flex-1 rounded-md bg-[#f5e6c5] text-[#2b170c] uppercase"
    />

    <button
      type="button"
      onClick={handleApplyCoupon}
      className="bg-[#C6A667] text-black px-4 py-2 rounded-md"
    >
      Uygula
    </button>
  </div>

  {couponError && (
    <p className="text-red-400 text-sm">
      {couponError}
    </p>
  )}

  {couponApplied && (
    <p className="text-green-400 text-sm">
      ✓ İş Ailem indirimi uygulandı.
    </p>
  )}
</div>

        {/* Kampanyalı Fiyat Özeti */}
<div className="border-t border-white/20 pt-4 space-y-2">

  <div className="flex justify-between">
    <span>Ara Toplam:</span>
    <span>{fmt(originalTotal)}</span>
  </div>

  {couponApplied && (
    <>
      <div className="flex justify-between text-green-400">
        <span>İş Ailem İndirimi:</span>
        <span>-{fmt(discountAmount)}</span>
      </div>

      <div className="text-xs opacity-70">
        Acı Olmayan Bitter Badem kategorisinde %50,
        diğer ürünlerde %20 indirim uygulanmıştır.
      </div>
    </>
  )}

  <div className="flex justify-between text-xl font-semibold">
    <span>Ödenecek Toplam:</span>
    <span>{fmt(finalTotal)}</span>
  </div>

</div>
        <div
  style={{
    marginTop: "12px",
    padding: "10px",
    backgroundColor: "#f5e6c5",
    color: "#2b170c",
    borderRadius: "8px",
    fontSize: "13px",
    textAlign: "center"
  }}
>
  📦 Kargo ücreti alıcıya aittir.
</div>

        <button
          type="submit"
          disabled={sending}
          className="bg-black text-[#C6A667] px-6 py-2 rounded-md hover:bg-[#111] transition w-full italic"
        >
          {sending ? "Yönlendiriliyor..." : "Ödeme Sayfasına Git"}
        </button>
        <div className="flex flex-col items-center mt-4 gap-2">
  <img
    src="/iyzicoblue.png"
    alt="İyzico Güvenli Ödeme"
    className="h-8 opacity-90"
  />
  <p className="text-xs opacity-70">
    Ödeme işlemi İyzico güvencesiyle gerçekleştirilir.
  </p>
</div>

      </form>
    </div>
  );
}


/* 🛒 Sepet sayfası */
function CartPage({ cart, incItem, decItem, navigateToCheckout }) {
  const navigate = useNavigate();
  const total = cart.reduce((sum, i) => sum + i.qty * i.price, 0);

  return (
    <div className="min-h-screen bg-transparent text-[#f5e6c5] pt-24 flex flex-col items-center italic">
      <button
        onClick={() => navigate("/")}
        className="mb-6 inline-flex items-center text-[#E8DCC3] gap-2 hover:underline"
      >
        <X size={20} /> Geri Dön
      </button>
      <h1 className="text-3xl font-gothic mb-6">Sepetiniz</h1>

      {cart.length === 0 ? (
        <p>Sepetiniz boş.</p>
      ) : (
        <div className="w-full max-w-3xl bg-[#1f120b]/80 backdrop-blur-md text-[#E8DCC3] shadow rounded-lg p-6">
          {cart.map((item, i) => (
            <div
              key={i}
              className="flex justify-between items-center border-b border-[#3a2415] py-3 gap-4"
            >
              <span className="flex-1">{item.name}</span>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => decItem(item.name, item.categoryId)}
                  className="bg-black text-[#C6A667] w-9 h-9 rounded-md hover:bg-[#111] transition"
                >
                  −
                </button>

                <span className="min-w-[32px] text-center">{item.qty}</span>

                <button
                  onClick={() => incItem(item.name, item.categoryId)}
                  className="bg-black text-[#C6A667] w-9 h-9 rounded-md hover:bg-[#111] transition"
                >
                  +
                </button>
              </div>

              <span className="min-w-[140px] text-right">
                {fmt(item.qty * item.price)}
              </span>
            </div>
          ))}

          <div className="text-right mt-4 font-semibold">
            Toplam: {fmt(total)}
          </div>

          <button
            onClick={navigateToCheckout}
            className="mt-6 bg-black text-[#C6A667] px-6 py-2 rounded-md hover:bg-[#111] transition"
          >
            Ödemeye Geç
          </button>
        </div>
      )}
    </div>
  );
}


/* 🏠 Ana sayfa */
function HomePage({ openProducts, selectedCat, setSelectedCat, addToCart }) {
  const navigate = useNavigate();

  const [activeProduct, setActiveProduct] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  const closeGallery = () => {
    setActiveProduct(null);
    setActiveImageIndex(0);
  };

  const showPrev = () => {
    if (!activeProduct?.images) return;
    setActiveImageIndex((i) => (i === 0 ? activeProduct.images.length - 1 : i - 1));
  };

  const showNext = () => {
    if (!activeProduct?.images) return;
    setActiveImageIndex((i) => (i === activeProduct.images.length - 1 ? 0 : i + 1));
  };

  return (
    <main className="pt-24 italic bg-transparent min-h-screen text-[#f5e6c5]">
        {!selectedCat && (
      <HeroCarousel
        onGoToCategory={(catId) => {
          const cat = CATEGORIES.find((c) => c.id === catId);
          if (cat) openProducts(cat); // kategori sayfasına gider
        }}
      />
    )}

      {!selectedCat &&
        CATEGORIES.map((cat) => (
          <section
            key={cat.id}
            className="h-screen relative flex items-center justify-center text-center overflow-hidden"
          >
            <img
              src={cat.image}
              alt={cat.name}
              className="absolute inset-0 w-full h-full object-cover brightness-60"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050909] via-transparent to-[#020405]" />
            <div className="relative z-10 w-full h-full">
  {/* SOL ÜST BLOK */}
  <div className="absolute top-8 left-8 flex flex-col items-start gap-4">
    
    <h2 className="text-4xl sm:text-5xl font-gothic text-[#F5E6C5] drop-shadow-lg text-left">
      {cat.name}
    </h2>

    <button
      onClick={() => openProducts(cat)}
      className="font-gothic bg-[#4A2C1A]/80 backdrop-blur-md text-[#E8DCC3] px-6 py-2 rounded-lg text-lg hover:bg-[#2D1A10] transition tracking-[0.12em]"
    >
      Ürünleri Gör
    </button>

  </div>
</div>

          </section>
        ))}

      {selectedCat && (
        <div className="min-h-screen bg-transparent py-20">
          <div className="max-w-5xl mx-auto text-center">
            <button
              onClick={() => {
                setSelectedCat(null);
                navigate("/");
              }}
              className="mb-6 inline-flex items-center text-[#E8DCC3] gap-2 hover:underline"
            >
              <X size={20} /> Geri Dön
            </button>

            <h2 className="text-4xl font-gothic mb-8 text-[#F5E6C5]">
              {selectedCat.name}
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
              {selectedCat.products?.map((p) => (
                <div
                  key={p.name}
                  className="bg-black/70 backdrop-blur-md text-[#E8DCC3] rounded-xl shadow-lg p-4 italic"
                >
                  <button
                    type="button"
                    onClick={() => {
                      if (p.images?.length > 0) {
                        setActiveProduct(p);
                        setActiveImageIndex(0);
                      }
                    }}
                    className="w-full aspect-square bg-[#f1e3d3] flex items-center justify-center rounded-lg text-[#4b2f18] mb-4 overflow-hidden"
                  >
                    {p.images?.[0] ? (
                      <img
                        src={p.images[0]}
                        alt={p.name}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      p.name
                    )}
                  </button>

                  <div className="flex justify-between items-center">
                    <span className="text-left">
                      <span className="font-gothic block text-lg">{p.name}</span>
                      <span className="text-sm text-[#F3D9A4]">{fmt(p.price)}</span>
                    </span>
                    <button
                      onClick={() =>
  addToCart({
    ...p,
    categoryId: selectedCat.id,
  })
}
                      className="bg-black text-[#C6A667] px-3 py-1 rounded-md text-sm hover:bg-[#111] transition"
                    >
                      Sepete Ekle
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      { activeProduct && (
  <div
    className="fixed inset-0 z-[200] bg-black/70 flex items-center justify-center p-4"
    onClick={closeGallery}
  >
    <div
      className="bg-[#1f120b]/90 backdrop-blur-md text-[#E8DCC3] rounded-2xl 
                 max-w-6xl w-full max-h-[90vh] p-6 relative 
                 flex flex-col lg:flex-row gap-6"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="absolute top-3 right-3 text-[#E8DCC3]"
        onClick={closeGallery}
      >
        <X size={24} />
      </button>

      {/* SOL TARAF - GÖRSEL */}
      <div className="flex-1 flex flex-col items-center justify-center">
        <h3 className="text-lg font-gothic mb-4 text-center">
          {activeProduct.name}
        </h3>

        <div className="relative mb-4 flex items-center justify-center w-full">
          <button
            onClick={showPrev}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full"
          >
            ‹
          </button>

          <img
            src={activeProduct.images[activeImageIndex]}
            className="max-h-[70vh] w-auto rounded-xl shadow"
            alt=""
          />

          <button
            onClick={showNext}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-black/40 text-white px-3 py-2 rounded-full"
          >
            ›
          </button>
        </div>

        {/* Thumbnail */}
        <div className="flex gap-2 flex-wrap justify-center">
          {activeProduct.images.map((img, i) => (
            <button
              key={i}
              onClick={() => setActiveImageIndex(i)}
              className={`h-16 w-16 rounded-md overflow-hidden border ${
                i === activeImageIndex
                  ? "border-[#C6A667] ring-2 ring-[#C6A667]/60"
                  : "border-gray-300"
              }`}
            >
              <img src={img} className="w-full h-full object-cover" alt="" />
            </button>
          ))}
        </div>
      </div>

      {/* SAĞ TARAF - AÇIKLAMA */}
<div className="flex-1 bg-[#2a1910]/60 rounded-xl p-6 overflow-y-auto max-h-[75vh]">
  <h4 className="text-xl font-semibold mb-4 text-[#C6A667]">
    Ürün Bilgileri
  </h4>

  <p className="text-sm leading-relaxed mb-4">
    {activeProduct.description || "Bu ürün el yapımı premium çikolatadır."}
  </p>

  <div className="text-sm space-y-2">
    <p><strong>Fiyat:</strong> {fmt(activeProduct.price)}</p>

    {activeProduct.material && (
      <p><strong>İçerik:</strong> {activeProduct.material}</p>
    )}

    {activeProduct.size && (
      <p><strong>Gramaj:</strong> {activeProduct.size}</p>
    )}
  </div>
</div>
    </div>
  </div>
)}
      {/* 📜 Parşömen Görseli */}
<div className="w-full flex justify-center mt-24">
  <img
    src="/parsomen.jpg"
    alt="Parşömen"
    className="max-w-5xl w-full opacity-90"
  />
</div>


      <footer className="bg-black/40 backdrop-blur-md text-[#f5e6c5] py-10 mt-20 text-center italic border-t border-[#0d3c44]">
        <h3 className="text-xl font-gothic mb-4">Hakkımızda</h3>
        <p className="max-w-xl mx-auto mb-4">
          
        </p>
        <div className="mt-6 flex flex-col items-center gap-3 text-sm">
          <div className="mt-6 flex justify-center">
  <img
    src="/iyzicowhite.png"
    alt="İyzico"
    className="h-10 opacity-80"
  />
</div>

  {/* Sözleşme (PDF veya sayfa) */}
  <a
    href="/sozlesme.pdf"
    target="_blank"
    rel="noreferrer"
    className="text-[#C6A667] underline hover:text-[#E8DCC3]"
  >
    Mesafeli Satış Sözleşmesi
  </a>

  {/* İletişim Linkleri */}
  <div className="flex flex-wrap justify-center gap-4">
    <a
      href="https://wa.me/905370636190"
      target="_blank"
      rel="noreferrer"
      className="text-[#C6A667] underline hover:text-[#E8DCC3]"
    >
      WhatsApp
    </a>

    <a
      href="https://instagram.com/bamor.chocolate"
      target="_blank"
      rel="noreferrer"
      className="text-[#C6A667] underline hover:text-[#E8DCC3]"
    >
      Instagram
    </a>

    <a
      href="mailto:ornek@bamor.com"
      className="text-[#C6A667] underline hover:text-[#E8DCC3]"
    >
      bamorglobalchocolate@gmail.com
    </a>
  </div>
</div>


        {/* Alt kısımdaki Gizli Admin Girişi */}
<div className="flex justify-center mt-8 pb-4">
  <button
    onClick={() => navigate("/admin")}
    className="transition-all duration-500 hover:scale-110 hover:brightness-125 opacity-40 hover:opacity-100"
    title="Admin"
  >
    <img 
      src="/bamor-tree.png" 
      alt="admin-login" 
      className="rounded-full shadow-lg border border-[#C6A667]/30"
      style={{ 
        width: '45px', 
        height: '45px', 
        objectFit: 'cover' 
      }} 
    />
  </button>
</div>
      </footer>
    </main>
  );
}

/* 🔗 Paylaşılabilir kategori bağlantısı */
function CategoryPage({ openProducts, selectedCat, setSelectedCat, addToCart }) {
  const { categoryId } = useParams();

  useEffect(() => {
    const category = CATEGORIES.find((cat) => cat.id === categoryId);
    setSelectedCat(category || null);
  }, [categoryId, setSelectedCat]);

  return (
    <HomePage
      openProducts={openProducts}
      selectedCat={selectedCat}
      setSelectedCat={setSelectedCat}
      addToCart={addToCart}
    />
  );
}

/* 📦 Sipariş takibi sayfası */
function OrderTrackPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      const qy = query(collection(db, "orders"), where("orderId", "==", orderId));
      const snapshot = await getDocs(qy);
      if (!snapshot.empty) {
        setOrder(snapshot.docs[0].data());
      }
      setLoading(false);
    };
    fetchOrder();
  }, [orderId]);

  useEffect(() => {
    if (order?.status === "Kargoda" && order?.kargoFirmasi && order?.takipNo) {
      const urls = {
        "Yurtiçi Kargo": `https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${order.takipNo}`,
        "MNG Kargo": `https://www.mngkargo.com.tr/gonderi-takip?no=${order.takipNo}`,
        "Aras Kargo": `https://kargotakip.araskargo.com.tr/mainpage.aspx?code=${order.takipNo}`,
      };
      const link = urls[	order.kargoFirmasi];
      if (link) {
        window.location.href = link;
      }
    }
  }, [order]);

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center italic bg-transparent text-[#f5e6c5]">
        Yükleniyor...
      </div>
    );

  if (!order)
    return (
      <div className="min-h-screen flex items-center justify-center italic bg-transparent text-[#f5e6c5]">
        Sipariş bulunamadı 😢
      </div>
    );

  return (
    <div className="min-h-screen bg-transparent flex flex-col items-center justify-center text-[#f5e6c5] p-6 italic">
      <h1 className="text-3xl font-gothic mb-4">Sipariş Takibi</h1>
      <p>
        <b>Sipariş Kodu:</b> {order.orderId}
      </p>
      <p>
        <b>Durum:</b> {order.status}
      </p>
      <p>
        <b>Toplam:</b> {fmt(order.total)}
      </p>
      {order.kargoFirmasi && order.takipNo && (
        <p className="mt-4">
          <b>Kargo:</b> {order.kargoFirmasi} — {order.takipNo}
        </p>
      )}
    </div>
  );
}



function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");
  const auth = getAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      // Şifre artık .env'de değil, Firebase'in güvenli sunucularında kontrol ediliyor
      await signInWithEmailAndPassword(auth, email, pass);
    } catch (err) {
      setError("Yetkisiz erişim veya hatalı bilgiler.");
      console.error("Giriş hatası:", err.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-transparent text-[#f5e6c5] italic">
      <h1 className="text-3xl font-gothic mb-6">🔐 Yönetim Paneli</h1>
      <form onSubmit={handleLogin} className="bg-[#1f120b]/80 p-8 rounded-xl shadow-2xl space-y-4 w-80">
        <input
          type="email"
          placeholder="Admin E-posta"
          className="w-full p-2 rounded bg-[#f5e6c5] text-[#2b170c]"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Şifre"
          className="w-full p-2 rounded bg-[#f5e6c5] text-[#2b170c]"
          onChange={(e) => setPass(e.target.value)}
          required
        />
        <button type="submit" className="w-full bg-[#C6A667] text-black font-bold py-2 rounded hover:bg-[#E8DCC3] transition">
          Giriş Yap
        </button>
        {error && <p className="text-red-500 text-sm text-center mt-2">{error}</p>}
      </form>
    </div>
  );
}

/* 🧭 Admin Panel */
function AdminPanel() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, "orders"), orderBy("createdAt", "desc"));

    getDocs(q).then((snapshot) => {
      const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setOrders(data);
      setLoading(false);
    });

    const unsub = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
      setOrders(data);
    });

    return () => unsub();
  }, []);

  const updateOrder = useCallback(
    debounce(async (id, field, value) => {
      await updateDoc(doc(db, "orders", id), { [field]: value });
    }, 500),
    []
  );

  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center italic bg-transparent text-[#f5e6c5]">
        Yükleniyor...
      </div>
    );

  return (
    <div className="min-h-screen bg-transparent p-6 text-[#f5e6c5] italic">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-gothic">📦 Sipariş Yönetim Paneli</h1>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-[#1f120b]/80 backdrop-blur-md text-[#E8DCC3] rounded-lg shadow">
          <thead>
            <tr className="bg-[#4A2C1A] text-white">
              <th className="p-3 text-left">Ad Soyad</th>
              <th className="p-3 text-left">Email</th>
              <th className="p-3 text-left">Toplam</th>
              <th className="p-3 text-left">Durum</th>
              <th className="p-3 text-left">Kargo Firması</th>
              <th className="p-3 text-left">Takip No</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.id} className="border-b border-[#3a2415] hover:bg-[#2b170c]">
                <td className="p-3">{o.name}</td>
                <td className="p-3">{o.email}</td>
                <td className="p-3">{fmt(o.total)}</td>
                <td className="p-3">
                  <select
                    className="border rounded p-1 bg-[#f5e6c5] text-[#2b170c]"
                    value={o.status}
                    onChange={(e) => updateOrder(o.id, "status", e.target.value)}
                  >
                    <option value="Hazırlanıyor">Hazırlanıyor</option>
                    <option value="Kargoda">Kargoda</option>
                    <option value="Teslim Edildi">Teslim Edildi</option>
                  </select>
                </td>
                <td className="p-3">
                  <select
                    className="border rounded p-1 bg-[#f5e6c5] text-[#2b170c]"
                    value={o.kargoFirmasi || ""}
                    onChange={(e) =>
                      updateOrder(o.id, "kargoFirmasi", e.target.value)
                    }
                  >
                    <option value="">Seçiniz</option>
                    <option value="Yurtiçi Kargo">Yurtiçi Kargo</option>
                    <option value="MNG Kargo">MNG Kargo</option>
                    <option value="Aras Kargo">Aras Kargo</option>
                  </select>
                </td>
                <td className="p-3">
                  <input
                    type="text"
                    className="border rounded p-1 w-32 bg-[#f5e6c5] text-[#2b170c]"
                    placeholder="Takip No"
                    value={o.takipNo || ""}
                    onChange={(e) => updateOrder(o.id, "takipNo", e.target.value)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ProtectedAdmin() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    // Firebase giriş durumunu izler
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      // Sadece senin e-postan giriş yaptıysa izin ver
      if (currentUser && currentUser.email === "bamortulay@gmail.com") {
        setUser(currentUser);
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [auth]);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#f5e6c5]">Yükleniyor...</div>;

  // Kullanıcı varsa paneli göster, yoksa giriş ekranını
  return user ? <AdminPanel /> : <AdminLogin />;
}

/* ✨ site iskeleti + header */
function AppContent() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [rightMenuOpen, setRightMenuOpen] = useState(false); // ✅ YENİ: Sağ menü durumu
  const [selectedCat, setSelectedCat] = useState(null);
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem("bamorCart");
    if (saved) setCart(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem("bamorCart", JSON.stringify(cart));
  }, [cart]);

  const openProducts = (cat) => {
    setSelectedCat(cat);
    navigate(`/kategori/${cat.id}`);
  };

  const handleCategoryClick = (catId) => {
    const cat = CATEGORIES.find((c) => c.id === catId);
    if (!cat) return;
    setSelectedCat(cat);
    navigate(`/kategori/${cat.id}`);
  };

  const addToCart = (item) =>
  setCart((prev) => {
    const existing = prev.find(
      (i) =>
        i.name === item.name &&
        i.categoryId === item.categoryId
    );

    if (existing) {
      return prev.map((i) =>
        i.name === item.name &&
        i.categoryId === item.categoryId
          ? { ...i, qty: i.qty + 1 }
          : i
      );
    }

    return [...prev, { ...item, qty: 1 }];
  });

  const clearCart = () => setCart([]);

  const incCartItem = (name, categoryId) => {
  setCart((prev) =>
    prev.map((i) =>
      i.name === name &&
      i.categoryId === categoryId
        ? { ...i, qty: i.qty + 1 }
        : i
    )
  );
};

const decCartItem = (name, categoryId) => {
  setCart((prev) =>
    prev
      .map((i) =>
        i.name === name &&
        i.categoryId === categoryId
          ? { ...i, qty: i.qty - 1 }
          : i
      )
      .filter((i) => i.qty > 0)
  );
};

  return (
    <>
      {/* 1. ÜST BAR  */}
      <header
        className="bamor-header topbar-gothic fixed top-0 left-0 w-full z-50 border-b border-[#09363c] shadow-md"
        style={{ backgroundColor: "#0E4A52" }}
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between text-[#F5E6C5]">
          <div
            className="font-gothic text-4xl cursor-pointer tracking-[0.15em]"
            onClick={() => {
              setSelectedCat(null);
              navigate("/");
            }}
          >
            BAMOREA
          </div>

          {/* Mobile Menü Butonu */}
          <button
            className="md:hidden bg-black/30 px-3 py-2 rounded-lg text-sm tracking-widest"
            onClick={() => setMobileMenuOpen(true)}
          >
            MENÜ
          </button>

          {/* Desktop Menü */}
          <nav className="hidden md:flex gap-8 text-lg gothic-decor">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleCategoryClick(cat.id)}
                style={{ fontFamily: '"Grenze Gotisch", serif' }}
              >
                {cat.name}
              </button>
            ))}
          </nav>

          <button
            className="flex items-center gap-3 text-xl shrink-0"
            onClick={() => navigate("/cart")}
          >
            <ShoppingCart />
            <span>{cart.reduce((sum, i) => sum + i.qty, 0)}</span>
          </button>
        </div>

        {/* Mobile Side Menu (Sol taraf için olan mevcut menün) */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 z-[999] md:hidden">
            <div
              className="absolute inset-0 bg-black/60"
              onClick={() => setMobileMenuOpen(false)}
            />
            <div className="absolute top-0 left-0 h-full w-72 bg-[#0E4A52] border-r border-[#09363c] shadow-2xl p-5">
              <div className="flex items-center justify-between mb-6">
                <div className="font-gothic text-2xl tracking-[0.12em] text-[#F5E6C5]">
                  MENÜ
                </div>
                <button
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#F5E6C5]"
                >
                  <X size={24} />
                </button>
              </div>
              <div className="flex flex-col gap-3">
                {CATEGORIES.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => {
                      handleCategoryClick(cat.id);
                      setMobileMenuOpen(false);
                    }}
                    className="text-left px-3 py-3 rounded-lg bg-black/20 text-[#F5E6C5] hover:bg-black/40 transition"
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
      </header>

      {/* 2. ✅ YENİ: SAĞ SABİT ENGLISH MENU BUTONU */}
      <div className="fixed right-2 top-1/2 -translate-y-1/2 z-[80] md:right-0">
  <button
    onClick={() => setRightMenuOpen(true)}
    className="bg-[#C6A667] text-black font-gothic py-8 px-3 rounded-l-2xl shadow-2xl hover:bg-[#F5E6C5] transition-all duration-300 border-l border-y border-[#09363c] whitespace-nowrap text-sm sm:text-base"
    style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
  >
    ENGLISH MENU
  </button>
</div>

      {/* 3. ✅ YENİ: SAĞDAN AÇILAN İNGİLİZCE PANEL */}
      <AnimatePresence>
        {rightMenuOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setRightMenuOpen(false)}
              className="fixed inset-0 bg-black/70 z-[100] backdrop-blur-sm"
            />
            <motion.div
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 200 }}
              className="fixed top-0 right-0 h-full w-[300px] bg-[#06343a] border-l border-[#C6A667]/30 z-[101] shadow-2xl p-8 overflow-y-auto"
            >
              <div className="flex justify-between items-center mb-10 border-b border-[#C6A667]/20 pb-4">
                <h2 className="font-gothic text-2xl text-[#C6A667] tracking-widest uppercase">
                  Collections
                </h2>
                <button onClick={() => setRightMenuOpen(false)} className="text-[#F5E6C5]">
                  <X size={28} />
                </button>
              </div>

              <nav className="flex flex-col gap-6">
                {CATEGORIES.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => {
                      handleCategoryClick(cat.id);
                      setRightMenuOpen(false);
                    }}
                    className="text-left group"
                  >
                    <span className="text-[#F5E6C5] font-gothic text-xl group-hover:text-[#C6A667] transition-colors italic">
                      {cat.enName || (cat.name.includes('/') ? cat.name.split('/')[1].trim() : cat.name)}
                    </span>
                    <div className="h-[1px] w-0 group-hover:w-full bg-[#C6A667] transition-all duration-300 mt-1" />
                  </button>
                ))}
              </nav>

              <div className="mt-20 border-t border-[#C6A667]/10 pt-8 text-sm text-[#F5E6C5]/50 italic">
                <p>Premium Handmade Chocolates</p>
                <p className="mt-2 text-[#C6A667]">BAMOREA Quality</p>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* 4. SAYFALAR */}
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              openProducts={openProducts}
              selectedCat={selectedCat}
              setSelectedCat={setSelectedCat}
              addToCart={addToCart}
            />
          }
        />
        <Route
          path="/kategori/:categoryId"
          element={
            <CategoryPage
              openProducts={openProducts}
              selectedCat={selectedCat}
              setSelectedCat={setSelectedCat}
              addToCart={addToCart}
            />
          }
        />
        <Route
          path="/cart"
          element={
            <CartPage
              cart={cart}
              incItem={incCartItem}
              decItem={decCartItem}
              navigateToCheckout={() => navigate("/checkout")}
            />
          }
        />
        <Route
          path="/checkout"
          element={<CheckoutPage cart={cart} clearCart={clearCart} />}
        />
        <Route path="/takip/:orderId" element={<OrderTrackPage />} />
        
        <Route path="/admin" element={<ProtectedAdmin />} />
        <Route path="/success" element={<PaymentSuccess />} />
        <Route path="/order-success" element={<PaymentSuccess />} />
      </Routes>
    </>
  );
}


/* 🚀 ana App */




export default function App() {
  const [introDone, setIntroDone] = useState(false);

  

  return (
    <Router>
      <AnimatePresence mode="wait">
        {!introDone ? (
          <IntroAnimation key="intro" onFinish={() => setIntroDone(true)} />
        ) : (
          <AppContent key="app" />
        )}
      </AnimatePresence>
    </Router>
  );
}
